import I18n from "../../i18n";

export default function btnHistory(id:string){
    return `
        <button type="button" id="${id}">
            ${I18n.apply("História da Assembleia")}
        </button>
    `;
}